module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"comments":"Comments"},"fr":{"comments":"Commentaires"}}')
  delete Component.options._Ctor
}
